export const state = () => ({
  accountSubpage: 'profile',
  meta: null,
  order: null,
  orders: null,
  orderType: null
});

export const mutations = {
  setAccountSubpage (state, subpage) {
    state.accountSubpage = subpage;
  },
  setMeta (state, meta) {
    state.meta = meta;
  },
  setOrder (state, order) {
    state.order = order;
  },
  setOrders (state, orders) {
    state.orders = orders;
  },
  setOrderType (state, orderType) {
    state.orderType = orderType;
  }
};

export const getters = {
  getAccountSubpage (state) {
    return state.accountSubpage;
  },
  getMeta (state) {
    return state.meta;
  },
  getOrder (state) {
    return state.order;
  },
  getOrders (state) {
    return state.orders;
  },
  getOrderType (state) {
    return state.orderType;
  }
};
